import React, { Component } from 'react';
import Radio from '@material-ui/core/Radio';

export default class SurveyRow extends Component {
  static propTypes = {

  };


  handleChange(event)
  {
    this.props.onChange({...this.props.data, availability: parseInt(event.target.value, 10)});
  }

  render() {

    //ffccca"}, {backgroundColor:"#dfa763"}, {backgroundColor:"#ffeda1"}, {backgroundColor:"#d1f3d1"
    let bgColor;
    switch (this.props.data.availability)
    {
      case 0:
        bgColor = "#ffa1a1";break;
      case 1:
        bgColor = "#ffbca1";break;
      case 2:
        bgColor = "#ffeda1";break;
      case 3:
        bgColor = "#d1f3d1";break;
      default:
        bgColor = "#fff";
    }

    let cols = [true, true, true, true];
    if (this.props.cols)
      cols = this.props.cols;

    return (
          <tr style={{backgroundColor:bgColor}}>
    <td>{this.props.data.what}<div style={{color:"#888"}}>{this.props.data.comment}</div></td>
          {cols[0] && <td><Radio  style={{padding:"0px"}} color="default"
        checked={this.props.data.availability === 3}
        onChange={this.handleChange.bind(this)}
        value={3}
        name="radio-button-date"/></td>}
          {cols[1] && <td><Radio   style={{padding:"0px"}} color="default"
        checked={this.props.data.availability === 2}
        onChange={this.handleChange.bind(this)}
        value={2}
        name="radio-button-date"/></td>
    }
          {cols[2] && <td><Radio  style={{padding:"0px"}}  color="default"
        checked={this.props.data.availability === 1}
        onChange={this.handleChange.bind(this)}
        value={1}
        name="radio-button-date"/></td>
  }
        {cols[3] &&
          <td><Radio  style={{padding:"0px"}}  color="default"
        checked={this.props.data.availability === 0}
        onChange={this.handleChange.bind(this)}
        value={0}
        name="radio-button-date"/></td>}
    </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/SurveyRow.js